import React from "react";
import {
  FloatingFocusManager,
  FloatingPortal,
  useMergeRefs,
} from "@floating-ui/react";

import { usePopoverContext } from "@components/organisms/popover/usePopoverContext";
import { Menu } from "@/components/atoms/menu";
import { MenuContent } from "@/components/atoms/menu/menu";

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(function PopoverContent({ style, ...props }, propRef) {
  const { context: floatingContext, ...context } = usePopoverContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!floatingContext.open) {
    return null;
  }

  return (
    <FloatingPortal>
      <FloatingFocusManager context={floatingContext} modal={context.modal}>
        <Menu
          ref={ref}
          style={{ ...context.floatingStyles, ...style }}
          // aria-labelledby={context.labelId}
          // aria-describedby={context.descriptionId}
          {...context.getFloatingProps(props)}
        >
          <MenuContent>{props.children}</MenuContent>
        </Menu>
      </FloatingFocusManager>
    </FloatingPortal>
  );
});
